export default __webpack_public_path__ + "static/media/shisui-eye.b201b441.png";